export default __webpack_public_path__ + "static/media/top-ten-1.20969145.svg";